import * as React from "react";
import Head from "next/head";
import Footer from "../components/Footer";
import Layout from "../components/Layout";
import Header from "../components/Header";
import LiveDisplaySetup from "../components/LiveDisplaySetup";

export default function IndexRoute() {
  return (
    <>
        <Head>
            <title>Live Display Setup - TacBoard</title>
            <meta name="description" content="Prepare for your event by setting up your display with these tutorials." />
            <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Aleo:200,300,400,700|Montserrat:300,400,500,700" />
           <link rel="canonical" href="https://tacboard.com/live-display-setup" />
        </Head>

      <Layout classes={["public"]}>
        <Header />
        <LiveDisplaySetup />
        <Footer />
      </Layout>
    </>
  );
};
